// extracted by mini-css-extract-plugin
export var actionButton = "_k7-t";
export var buttonContainer = "_k7-0";
export var buttonContainer2 = "_k7-1";
export var buttonSection = "_k7-2";
export var details = "_k7-3";
export var dropdownItem = "_k7-5";
export var dropdownItemsContainer = "_k7-4";
export var fileInput = "_k7-r";
export var headerButton = "_k7-6";
export var icon = "_k7-7";
export var input = "_k7-8";
export var macroListItem = "_k7-9";
export var mainContent = "_k7-a";
export var microText = "_k7-b";
export var modal = "_k7-w";
export var optionsButton = "_k7-c";
export var paperclip = "_k7-s";
export var pillContent = "_k7-d";
export var preview = "_k7-e";
export var preview2 = "_k7-f";
export var quillEditor = "_k7-q";
export var selectedMacro = "_k7-g";
export var sidebar = "_k7-h";
export var sidebarHeader = "_k7-j";
export var sidebarList = "_k7-i";
export var sidebarListItem = "_k7-k";
export var sidebarSearch = "_k7-l";
export var snoozeDurationWrapper = "_k7-v";
export var statusPillContainer = "_k7-m";
export var tagsContainer = "_k7-n";
export var unselectedMacro = "_k7-o";
export var variable = "_k7-u";
export var wrapper = "_k7-p";